import { JobDefinitionState } from 'ducks/job-definition/slices';
import { ProjectsJobDefinitionsListAPI } from 'ducks/types/api-types';
import { ProjectParameters, RunJobDefinitionParameters } from 'ducks/types/store-types';
import { normalizeJobDefinition } from 'ducks/utils';
import { JobFormState } from 'modals/job-definition/constants';

export function normalizeJobDefinitions(data: ProjectsJobDefinitionsListAPI[]) {
  return data.map((definition) => normalizeJobDefinition(definition)).sortObject('job_definition_name', 'asc');
}

export const getRunJobDefinitionParameters = (parameters: ProjectParameters): RunJobDefinitionParameters[] => {
  return parameters
    .filter((p) => !!p.parameter_name || p.delete)
    .map((p) => ({
      parameter_name: p.parameter_name,
      parameter_direction_id: p.parameter_direction_id,
      parameter_method_id: p.parameter_method_id,
      is_required: p.is_required,
      is_encrypted: p.is_encrypted,
      parameter_value: p.parameter_value,
      description: p.description,
      command_line_prefix: p.command_line_prefix,
      command_line_assignment_char: p.command_line_assignment_char,
      command_line_escaped: p.command_line_escaped,
      command_line_ignore_name: p.command_line_ignore_name,
      reference_type_id: p.reference_type_id,
      reference_id: p.reference_id,
      reference_parameter_name: p.reference_parameter_name,
    }));
};

export const getRunJobDefinitionPayload = (data: JobFormState) => {
  const {
    batch_descriptor,
    cpu,
    gpu,
    shared_memory_mb,
    memory_gb,
    storage_gb,
    timeout_seconds,
    max_retries,
    cpu_architecture_id,
    location_group_id,
    billing_identifier,
    prevent_preemption,
    description,
    docker_image,
    startup_command,
    result_method_id,
    stdout_success_text,
  } = data;

  return {
    batch_id: null,
    batch_descriptor,
    cpu,
    gpu,
    memory_gb,
    storage_gb,
    shared_memory_mb,
    timeout_seconds,
    max_retries,
    location_group_id,
    billing_identifier,
    prevent_preemption,
    cpu_architecture_id,
    description,
    docker_image,
    startup_command,
    result_method_id,
    stdout_success_text,
    depends_on: [],
    input_file_id_list: [],
    output_file_id_list: [],
    parameters: [] as RunJobDefinitionParameters[],
  };
};

export const getUpdatedDefinition = (data: JobDefinitionState) => {
  return {
    job_definition_name: data.job_definition_name,
    job_definition_id: data.job_definition_id,
    prevent_preemption: data.prevent_preemption,
    billing_identifier: data.billing_identifier,
    description: data.description,
    docker_image: data.docker_image,
    result_method_id: data.result_method_id,
    startup_command: data.startup_command,
    timeout_seconds: data.timeout_seconds,
    stdout_success_text: data.stdout_success_text,
    location_group_id: data.location_group_id,
    cpu: data.cpu,
    gpu: data.gpu,
    storage_gb: data.storage_gb,
    shared_memory_mb: data.shared_memory_mb,
    cpu_architecture_id: data.cpu_architecture_id,
    max_retries: data.max_retries,
    memory_gb: data.memory_gb,
  };
};
